export default __webpack_public_path__ + "static/media/hold_new_icon.7368dcb0.svg";